import React, { useState } from 'react';
import PropTypes from 'prop-types';

import UpturnCardBlock from '../UpturnCardBlock';

import styles from './styles.module.scss';

const UpturnCard = ({ backCard, frontCard }) => {
	const [cardActive, setCardActive] = useState(false);
	const hasBackRoundImage = backCard?.imageType === 'round';
	const hasFrontRoundImage = frontCard?.imageType === 'round';
	const isReverseMainSideStyle =
		(hasFrontRoundImage || frontCard?.imageType === 'center') &&
		backCard?.imageType === 'cover';

	const onClickCard = () => {
		setCardActive(!cardActive);
	};

	return (
		<button className={styles.UpturnCard} onClick={onClickCard} type="button">
			<UpturnCardBlock
				card={frontCard}
				hasRoundImageOtherSide={hasBackRoundImage}
				isActive={cardActive}
				isReverseSideStyle={isReverseMainSideStyle}
				position="front"
			/>
			<UpturnCardBlock
				card={backCard}
				hasRoundImageOtherSide={hasFrontRoundImage}
				isActive={cardActive}
				isReverseSideStyle={isReverseMainSideStyle}
				position="back"
			/>
		</button>
	);
};

UpturnCard.propTypes = {
	backCard: PropTypes.object.isRequired,
	frontCard: PropTypes.object.isRequired
};

export default UpturnCard;
